import { createGlobalStyle } from 'styled-components';
export const SideNavOverrideStyles = createGlobalStyle(({
  theme
}) => {
  return {
    '#scroll-container [data-is-active="true"]::before': {
      borderLeftColor: theme.color['specialty-tertiary-on-fill-default']
    }
  };
});